import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Fieldset } from "primereact/fieldset";
import { timesheetApi, Util } from "../../services";
import { utitService } from "../../services/util";
import RecallTimesheetForm from "../timesheets/dialogBox/recallTimesheet";
import RequestRecallTimesheetPopup from "../timesheets/dialogBox/requestRecallTimesheet";
import AddTimesheetActivityForm from "../timesheets/dialogBox/addTimesheetActivityForm";
import { toast } from "react-toastify";
import { Card } from "primereact/card";
import { SelectButton } from "primereact/selectbutton";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Fragment } from "react";
import { confirmDialog } from "primereact/confirmdialog";
import { InputTextarea } from "primereact/inputtextarea";
import moment from "moment";
import { submitFutureDateTimesheet } from "../../common/util/constants";

const EmployeeManagerTimesheet = () => {
  const [newTimesheetActivityDialog, setNewTimesheetActivityDialog] =
    useState(false);
  const [clickedDraftTimesheetId, setClickedDraftTimesheetId] = useState("");
  const [clickedDraftTimesheetHrs, setClickedDraftTimesheetHrs] = useState("");
  const [clickedActivityType, setClickedActivityType] = useState("");
  /* Review Pagination */
  const navigate = useNavigate();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [rejectedDisabled, setRejectedDisabled] = useState(true);
  const [totalHrWarning, setTotalHrWarning] = useState(false);
  const [totalHrError, setTotalHrError] = useState(false);
  /* Review Pagination */
  // const [updatedData, setUpdateData] = useState([]);
  const [draftTimesheetList, setDraftTimesheetList] = useState([]);
  const [rejectTimesheetList, setRejectTimesheetList] = useState([]);
  const [lockTimesheetList, setLockTimesheetList] = useState([]);
  const [lockedDialog, setLockedDialog] = useState(false);
  const [currentLockedRow, setCurrentLockedRow] = useState({});
  const [selectedDraftTimesheet, setSelectedDraftTimesheet] = useState([]);
  const [expandedDraftRows, setExpandedDraftRows] = useState(null);
  const [expandedRejectedRows, setExpandedRejectedRows] = useState(null);
  const [reviewTimesheetList, setReviewTimesheetList] = useState([]);
  const [selectedReviewTimesheet, setSelectedReviewTimesheet] = useState([]);
  const [approveTimesheetList, setApproveTimesheetList] = useState([]);
  const [approvedDialog, setApprovedDialog] = useState(false);
  const [currentApprovedRow, setCurrentApprovedRow] = useState({});
  const [selectedApproveTimesheet, setSelectedApproveTimesheet] = useState([]);
  const [selectedRejectTimesheet, setSelectedRejectTimesheet] = useState([]);
  const [recallDialog, setRecallDialog] = useState(false);
  const [multipleRecallDialog, setMultipleRecallDialog] = useState(false);
  const [reqRecallDialog, setReqRecallDialog] = useState(false);
  const [multipleReqRecallDialog, setMultipleReqRecallDialog] = useState(false);
  const dt = useRef(null);
  let currentPage = 0;
  const [editRecallData, setEditRecallData] = useState({});
  const [editMultipleRecallData, setEditMultipleRecallData] = useState({});
  const [editReqRecallData, setEditReqRecallData] = useState({});
  const [editMultipleReqRecallData, setEditMultipleReqRecallData] = useState(
    {},
  );
  const [draftAction, setDraftAction] = useState(true);
  const [reviewAction, setReviewAction] = useState(false);
  const [approveAction, setApproveAction] = useState(false);
  const [lockedAction, setLockedAction] = useState(false);
  const [rejectAction, setRejectAction] = useState(false);
  const [timeshetTab, setTimeshetTab] = useState("Draft");
  const [timesheetDialog, setTimesheetDialog] = useState(false);
  const [editableDraftTimesheet, setEditableDraftTimesheet] = useState([]);
  const [draftRowIndex, setDraftRowIndex] = useState("");
  const [currentRow, setCurrentRow] = useState({});
  const [currentCol, setCurrentCol] = useState({});
  const [type, setType] = useState("draft");
  const [updatedActivity, setUpdatedActivity] = useState(null);
  const [updatedCategory, setUpdatedCategory] = useState(null);

  const [filterMonth, setFilterMonth] = useState(new Date());
  const [draftTimesheetCount, setDraftTimesheetCount] = useState(0);
  const [reviewTimesheetCount, setReviewTimesheetCount] = useState(0);
  const [approveTimesheetCount, setApproveTimesheetCount] = useState(0);
  const [lockTimesheetCount, setLockTimesheetCount] = useState(0);
  const [rejectTimesheetCount, setRejectTimesheetCount] = useState(0);
  const [allocatedProjectData, setAllocatedProjectData] = useState([]);
  const [reviewRecallDisabled, setReviewRecallDisabled] = useState(true);
  const [approvedRecallDisabled, setApprovedRecallDisabled] = useState(true);
  const [startFilterDate, setStartFilterDate] = useState("");
  const [endFilterDate, setEndFilterDate] = useState("");
  const [mapCategory, setMapCategory] = useState(null);
  const [hoursInputStatus, setHoursInputStatus] = useState(false);
  const [currentReviewRow, setCurrentReviewRow] = useState({});
  const [reviewDialog, setReviewDialog] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [clickedDraftTimesheetDate, setClickedDraftTimesheetDate] =
    useState("");
  var count = 0;
  useEffect(() => {
    if (count == 0) {
      fetchDraftTimesheetData({ status: "DRAFT" });
      count++;
    }
  }, []);

  /* Employee/Manager Allocated Project List Start */
  const fetchAllocatedProjectData = (param = {}) => {
    timesheetApi.getAllocatedProject(param).then((resp) => {
      try {
        const activeProjects = resp.data.data.filter((x) => {
          return x.status === 1;
        });
        setAllocatedProjectData(activeProjects);
      } catch (error) {
        // Error handle
      }
    });
  };

  /* For Edit Timesheet Activity Start */
  const editTimesheetActivity = (rowData, rowIndex, t) => {
    fetchAllocatedProjectData();
    setType(t);
    setCurrentRow(rowData);
    setCurrentCol(rowIndex);
    setEditableDraftTimesheet(rowData);
    setDraftRowIndex(rowIndex);
    setTimesheetDialog(true);
  };

  /* For Add Timesheet Activity Start */
  const addTimesheetActivity = (rowData, type) => {
    fetchAllocatedProjectData();
    setClickedActivityType(type);
    setClickedDraftTimesheetId(rowData.id);
    setClickedDraftTimesheetHrs(rowData.totalHours);
    setClickedDraftTimesheetDate(rowData.date);
    setNewTimesheetActivityDialog(true);
  };
  const onHide = () => {
    setNewTimesheetActivityDialog(false);
    setTimesheetDialog(false);
  };

  /* Dialog Box for Add/Edit Transit Info Form Start */
  const closeActivityDialoge = () => {
    setNewTimesheetActivityDialog(false);
    if (clickedActivityType === "draft") {
      fetchDraftTimesheetData({
        status: "DRAFT",
        startDate: startFilterDate,
        endDate: endFilterDate,
      });
    } else {
      fetchRejectTimesheetData({
        status: "REJECT",
        startDate: startFilterDate,
        endDate: endFilterDate,
      });
    }
  };

  const NewTimesheetActivityDialog = () => {
    return (
      <Dialog
        className="pop-up-dialog"
        header="Add Timesheet"
        visible={newTimesheetActivityDialog}
        onHide={() => onHide()}
      >
        <AddTimesheetActivityForm
          onClose={(e) => {
            closeActivityDialoge();
          }}
          projectList={allocatedProjectData}
          timesheetId={clickedDraftTimesheetId}
          timesheetDate={clickedDraftTimesheetDate}
          totaltimesheethours={clickedDraftTimesheetHrs}
          activityListData={
            clickedActivityType === "draft"
              ? draftTimesheetList
              : rejectTimesheetList
          }
        />
      </Dialog>
    );
  };

  const ChargeableOrNot = (el) => {
    return el?.isBillable ? (
      <span style={{ color: "green" }}>Chargeable</span>
    ) : (
      <span style={{ color: "red" }}>Non Chargeable</span>
    );
  };

  const hoursRoundOff = (item) => {
    return item.totalHours?.toFixed(2);
  };
  /* Dialog Box for Add/Edit Transit Info Form End */

  const updateTimesheet = (newData) => {
    timesheetApi.updateDraftData(newData).then(
      (resp) => {
        if (resp) {
          const param = {
            id: newData.timesheetId,
            totalHours: newData.hours,
          };
          updateTimesheetActivity(param, type);
        }
      },
      (err) => {
        toast.error("Unable to update timesheet...");
      },
    );
  };

  /* For Add Timesheet Activity End */
  const TimesheetDlg = () => {
    const [editTimesheet, setEditTimesheet] = useState({});
    const [currentProject, setCurrentProject] = useState({});
    const [lookup, setLookup] = useState({ categories: [], activities: [] });
    // state for inline add entry
    const [newEntry, setNewEntry] = useState({
      categoryId: null,
      activityId: null,
      hours: "",
      jiraTaskId: "",
      description: "",
    });
    const [newEntryLookup, setNewEntryLookup] = useState({
      categories: [],
      activities: [],
    });
    useEffect(() => {
      if (currentRow.timesheetProjects) {
        const editData = currentRow.timesheetProjects[0];
        const projectId = editData.projectId;
        const currentProjectInfo = allocatedProjectData.find(
          (x) => x.Project.id === projectId,
        );
        setCurrentProject(currentProjectInfo?.Project);
        if (currentProjectInfo) {
          setLookup({
            categories: currentProjectInfo?.Project?.categories || [],
            activities: currentProjectInfo?.Project?.activities || [],
          });
          // also set lookup for add entry section
          setNewEntryLookup({
            categories:
              currentProjectInfo?.Project?.categories?.filter(
                (c) =>
                  (c.userId === currentUser.id || c.userId === null) &&
                  c.status === 1,
              ) || [],
            activities:
              currentProjectInfo?.Project?.activities?.filter(
                (a) =>
                  (a.userId === currentUser.id || a.userId === null) &&
                  a.status === 1,
              ) || [],
          });
        }
        setEditTimesheet(editData);
      }
    }, [currentRow, allocatedProjectData]);

    // handle inline add entry submit
    const handleAddInlineEntry = () => {
      //  Basic validation
      if (!newEntry.categoryId || !newEntry.activityId || !newEntry.hours) {
        toast.error("Please fill Category, Activity and Hours");
        return;
      }
      //Find isBillable — same as addTimesheetActivityForm
      const currentProjectInfo = allocatedProjectData.find(
        (x) => x.Project.id === currentRow.timesheetProjects[0]?.projectId,
      );
      const activityIsBillable = currentProjectInfo?.Project?.activities?.find(
        (item) => item.id === newEntry.activityId,
      );
      // Build payload — exact same fields as addTimesheetActivityForm
      const addedActivityData = {
        timesheetId: currentRow.id,
        date: currentRow.date,
        projectId: currentRow.timesheetProjects[0]?.projectId,
        categoryId: newEntry.categoryId,
        activityId: newEntry.activityId,
        isBillable: activityIsBillable?.isBillable,
        hours: parseFloat(newEntry.hours),
        jiraTaskId: newEntry.jiraTaskId,
        description: newEntry.description,
      };
      // Duplicate check — same as addTimesheetActivityForm
      const isDuplicate = currentRow.timesheetProjects.filter((x) => {
        return (
          x.activityId === addedActivityData.activityId &&
          x.categoryId === addedActivityData.categoryId
        );
      });
      //  enforce exactly 8 total hours when adding inline entry for ESAU region
      const isEsauUser = currentUser?.LegalEntity?.code === "ESAU";
      const wouldBeTotal = addedActivityData.hours + currentRow.totalHours;
      if (isEsauUser && wouldBeTotal !== 8) {
        toast.error(
          "Total working hours must be exactly 8 hours per day. Adding this entry would result in " +
            parseFloat(wouldBeTotal).toFixed(2) +
            " hours.",
        );
        return;
      } else if (!isEsauUser && wouldBeTotal > 24) {
        toast.error("You cannot add more than 24 hours");
        return;
      }
      if (isDuplicate.length > 0) {
        toast.error("You cannot add duplicate timesheet activity!");
        return;
      }
      //  Save activity
      try {
        timesheetApi.saveTimesheetActivityData(addedActivityData).then(
          (resp) => {
            if (resp.status === 201) {
              // Update total hours
              // Calculate existing total + new hours
              const existingTotal = currentRow.timesheetProjects.reduce(
                (acc, curr) => acc + parseFloat(curr.hours),
                0,
              );
              const newTotal = existingTotal + parseFloat(newEntry.hours);
              if (newTotal <= 24) {
                const param = {
                  id: currentRow.id,
                  totalHours: newTotal,
                };
                try {
                  timesheetApi.updateTimesheet(param).then(
                    (resp) => {
                      if (resp) {
                        toast.info("Activity added successfully...");
                        // Reset form
                        setNewEntry({
                          categoryId: null,
                          activityId: null,
                          hours: "",
                          jiraTaskId: "",
                          description: "",
                        });
                        setTimesheetDialog(false);
                        // Refresh correct list
                        if (type === "draft") {
                          fetchDraftTimesheetData({
                            status: "DRAFT",
                            startDate: startFilterDate,
                            endDate: endFilterDate,
                          });
                        } else {
                          fetchRejectTimesheetData({
                            status: "REJECT",
                            startDate: startFilterDate,
                            endDate: endFilterDate,
                          });
                        }
                      }
                    },
                    () => toast.error("Unable to update total hours..."),
                  );
                } catch (error) {
                  toast.error("Unable to update total hours...");
                }
              }
            }
          },
          (resp) => {
            toast.error(resp?.response?.data?.error || "Unable to add entry");
          },
        );
      } catch (error) {
        toast.error("Unable to create timesheet activity...");
      }
    };
    return (
      <Dialog
        className="pop-up-dialog ess-page custom_popup"
        resizable={false}
        header={`Edit ${type} Timesheet`}
        visible={timesheetDialog}
        style={{ width: "90vw" }}
        onHide={() => onHide()}
      >
        <div className="ess-table">
          <DataTable
            key={"edit"}
            columnResizeMode="fit"
            scrollable="horizontal"
            responsiveLayout="scroll"
            value={currentRow?.timesheetProjects}
            editMode="row"
            onRowEditComplete={(e) =>
              onTimesheetActivityEdit(e, currentCol, type)
            }
          >
            <Column
              field="id"
              header="Id"
              style={{ minWidth: "8rem" }}
            ></Column>
            <Column
              field=""
              header="Project"
              body={projectBodyTemplate}
              style={{ minWidth: "15rem" }}
            ></Column>
            <Column
              field="categoryId"
              header="Category"
              editor={(options) => listEditor(options)}
              style={{ minWidth: "8rem" }}
              body={(options) => listBodyTemplate(options, "category")}
            ></Column>
            <Column
              field="activityId"
              header="Activity"
              editor={(options) => listEditor(options)}
              style={{ minWidth: "8rem" }}
              body={(options) => listBodyTemplate(options, "activity")}
            ></Column>
            <Column
              header="Billing Type"
              style={{ minWidth: "10rem" }}
              body={ChargeableOrNot}
            ></Column>
            <Column
              field="jiraTaskId"
              header="JIRA / Task ID "
              style={{ minWidth: "10rem" }}
              editor={(options) => textJiraTaskId(options)}
            ></Column>
            <Column
              field="description"
              header="Description"
              editor={(options) => textDescription(options)}
              style={{ minWidth: "13rem" }}
            ></Column>
            <Column
              field="hours"
              header="Total Hours"
              editor={(options) => textEditor(options)}
              style={{ minWidth: "8rem" }}
            ></Column>
            <Column
              rowEditor
              style={{ minWidth: "8rem" }}
              bodyStyle={{ textAlign: "end", paddingRight: "6px" }}
            ></Column>
            <Column
              field=""
              header=""
              style={{ paddingLeft: "0px" }}
              body={(e) => timesheetActivityDeleteTemplate(e, currentCol, type)}
            ></Column>
          </DataTable>
          {/* Inline Add Entry Section */}
          <div
            className="p-fluid formgrid grid mt-3 p-3"
            style={{
              background: "#f8f9fa",
              borderRadius: "6px",
              alignItems: "flex-end",
            }}
          >
            <div className="col-12 mb-2">
              <h5 style={{ margin: 0 }}>Add New Entry</h5>
            </div>
            <div className="field col-12 md:col-2">
              <label>
                Category<span className="ess-danger">*</span>{" "}
              </label>
              <Dropdown
                filter
                value={newEntry.categoryId}
                options={newEntryLookup.categories}
                optionLabel="title"
                optionValue="id"
                placeholder="Select Category"
                onChange={(e) =>
                  setNewEntry({ ...newEntry, categoryId: e.value })
                }
              />
            </div>
            <div className="field col-12 md:col-2">
              <label>
                Activity<span className="ess-danger">*</span>
              </label>
              <Dropdown
                filter
                value={newEntry.activityId}
                options={newEntryLookup.activities}
                optionLabel="title"
                optionValue="id"
                placeholder="Select Activity"
                itemTemplate={Util.activityItemBody}
                onChange={(e) =>
                  setNewEntry({ ...newEntry, activityId: e.value })
                }
              />
            </div>
            <div className="field col-12 md:col-1">
              <label>
                Hours<span className="ess-danger">*</span>
              </label>
              <InputText
                value={newEntry.hours}
                placeholder="Hours"
                maxLength={5}
                onKeyPress={Util.preventCharWithMinus}
                onPaste={Util.preventPasteChar}
                onChange={(e) =>
                  setNewEntry({ ...newEntry, hours: e.target.value })
                }
              />
            </div>
            <div className="field col-12 md:col-2">
              <label>JIRA/Task ID</label>
              <InputText
                value={newEntry.jiraTaskId}
                placeholder="JIRA/Task ID"
                onChange={(e) =>
                  setNewEntry({ ...newEntry, jiraTaskId: e.target.value })
                }
              />
            </div>
            <div className="field col-12 md:col-3">
              <label>Description</label>
              <InputTextarea
                value={newEntry.description}
                placeholder="Description"
                rows={1}
                onChange={(e) =>
                  setNewEntry({ ...newEntry, description: e.target.value })
                }
              />
            </div>
            <div className="field col-12 md:col-2">
              <label>&nbsp;</label>
              <Button
                label="Add"
                icon="pi pi-check"
                className="p-button-rounded"
                onClick={handleAddInlineEntry}
              />
            </div>
          </div>
          {/* END: Inline Add Entry Section */}
        </div>
      </Dialog>
    );
  };

  const changeTimesheetTab = (e) => {
    // setFilterMonth(new Date());
    const now = new Date(filterMonth);
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const fd = moment(firstDay).format("DD");
    const ld = moment(lastDay).format("DD");
    const m = moment(filterMonth).format("MM");
    const y = moment(filterMonth).format("YYYY");
    let sDate = fd + "-" + m + "-" + y;
    let eDate = ld + "-" + m + "-" + y;

    setStartFilterDate(sDate);
    setEndFilterDate(eDate);

    setTimeshetTab(e.value);
    var tab = e.value;
    var a = [];
    a = tab.split(" ");
    tab = a[0];
    switch (tab) {
      case "Draft":
        setSelectedDraftTimesheet([]);
        setSaveDisabled(true);
        setExpandedDraftRows(null);
        setDraftAction(true);
        setReviewAction(false);
        setApproveAction(false);
        setLockedAction(false);
        setRejectAction(false);
        fetchDraftTimesheetData({
          status: "DRAFT",
          startDate: sDate,
          endDate: eDate,
        });
        break;
      case "Review":
        setSaveDisabled(true);
        setRejectedDisabled(true);
        setReviewAction(true);
        setDraftAction(false);
        setApproveAction(false);
        setLockedAction(false);
        setRejectAction(false);
        setSelectedReviewTimesheet(null);
        fetchReviewTimesheetData({
          status: "REVIEW",
          startDate: sDate,
          endDate: eDate,
        });
        break;
      case "Approved":
        setSaveDisabled(true);
        setRejectedDisabled(true);
        setApproveAction(true);
        setLockedAction(false);
        setReviewAction(false);
        setDraftAction(false);
        setRejectAction(false);
        setSelectedApproveTimesheet(null);
        fetchApproveTimesheetData({
          status: "APPROVED",
          startDate: sDate,
          endDate: eDate,
        });

        break;
      case "Locked":
        setSaveDisabled(true);
        setApproveAction(false);
        setLockedAction(true);
        setReviewAction(false);
        setDraftAction(false);
        setRejectAction(false);
        fetchLockTimesheetData({
          status: "LOCKED",
          startDate: sDate,
          endDate: eDate,
        });
        break;
      case "Rejected":
        setSelectedRejectTimesheet([]);
        setRejectedDisabled(true);
        setExpandedRejectedRows(null);
        setRejectAction(true);
        setApproveAction(false);
        setLockedAction(false);
        setReviewAction(false);
        setDraftAction(false);
        fetchRejectTimesheetData({
          status: "REJECT",
          startDate: sDate,
          endDate: eDate,
        });
        break;
      default:
        setExpandedDraftRows(null);
        setDraftAction(true);
        setReviewAction(false);
        setApproveAction(false);
        setLockedAction(false);
        setRejectAction(false);
        fetchDraftTimesheetData({
          status: "DRAFT",
          startDate: sDate,
          endDate: eDate,
        });
        break;
    }
  };

  const justifyTemplate = (option) => {
    return option.value + "-" + option.count;
  };

  /* Toolbar Section Start */
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <SelectButton
          className="Tab-Buttons"
          value={timeshetTab}
          options={[
            { count: draftTimesheetCount, value: "Draft" },
            { count: reviewTimesheetCount, value: "Review" },
            { count: approveTimesheetCount, value: "Approved" },
            { count: lockTimesheetCount, value: "Locked" },
            { count: rejectTimesheetCount, value: "Rejected" },
          ]}
          onChange={(e) => changeTimesheetTab(e)}
          itemTemplate={justifyTemplate}
        />
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div>
        <Calendar
          value={filterMonth}
          onChange={filterByMonth}
          view="month"
          dateFormat="mm-yy"
          yearNavigator
          yearRange={"2010:" + new Date().getFullYear().toString()}
          showIcon
        />
        <Button
          label="Start Creating Timesheet"
          icon="pi pi-plus"
          className="p-button-rounded p-button-secondary ml-1"
          onClick={() => navigate("/create-timesheet")}
        />
      </div>
    );
  };
  /* Toolbar Section End */

  /* Grid Action on Column Body Start */
  const projectBodyTemplate = (rowData) => {
    return rowData.projectDetails ? rowData.projectDetails.title : "";
  };
  const categoryBodyTemplate = (rowData) => {
    return rowData.categories ? rowData.categories.title : "";
  };
  const activityBodyTemplate = (rowData) => {
    return rowData.activities ? rowData.activities.title : "";
  };

  const textEditor = (options) => {
    // if (options?.rowData?.categoryId === 635) {
    //   setHoursInputStatus(true);
    // } else {
    //   setHoursInputStatus(false);
    // }
    return (
      <InputText
        style={{ width: "80px" }}
        type="text"
        value={options.value}
        maxLength={5}
        maxfractiondigits={2}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyPress={Util.preventCharWithMinus}
        onPaste={Util.preventPasteChar}
      />
    );
  };

  const textDescription = (options) => {
    return (
      <InputTextarea
        style={{ width: "150px" }}
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        rows={1}
        cols={30}
      />
    );
  };

  const textJiraTaskId = (options) => {
    return (
      <InputTextarea
        style={{ width: "150px" }}
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        rows={1}
        cols={30}
      />
    );
  };
  var currentUser = JSON.parse(localStorage.getItem("user"));

  const changeActivity = (e) => {
    setUpdatedActivity(e);
  };

  const changeCategory = (e) => {
    setUpdatedCategory(e);
  };
  const listEditor = (options, props) => {
    let list = [];
    let field = "name";
    let fieldval = "id";
    switch (options.field) {
      case "activityId":
        var obj = allocatedProjectData.find((x) => {
          return x.Project.title == options.rowData.projectDetails.title;
        });
        // var userActList = obj?.Project.activities.filter((obj) => { return obj.status === 1; });
        var userActList = obj?.Project.activities.filter((obj) => {
          if (mapCategory) {
            if (mapCategory?.code == "LH") {
              return (
                (obj.userId === currentUser.id || obj.userId === null) &&
                obj.status === 1 &&
                obj.type === "0"
              );
            } else {
              return (
                (obj.userId === currentUser.id || obj.userId === null) &&
                obj.status === 1 &&
                obj.type === "1"
              );
            }
          } else {
            return (
              (obj.userId === currentUser.id || obj.userId === null) &&
              obj.status === 1
            );
          }
        });
        list = userActList;
        fieldval = "id";
        field = "title";
        let v1 = userActList.find((x) => {
          return x.id == options.rowData.activityId;
        });
        if (v1) {
          options.value = v1;
        } else {
          options.value = updatedActivity;
        }
        return (
          <Fragment>
            <Dropdown
              filter
              value={options.value}
              options={list}
              optionLabel={field}
              onChange={(e) => {
                options.editorCallback(e.value);
                changeActivity(e.value);
              }}
              placeholder="Select Activity"
              itemTemplate={Util.activityItemBody}
            />
          </Fragment>
        );
        break;
      case "categoryId":
        setMapCategory(options.value);
        var obj = allocatedProjectData.find((x) => {
          return x.Project.title == options.rowData.projectDetails.title;
        });
        var userCatList = obj?.Project.categories.filter((obj) => {
          return (
            (obj.userId === currentUser.id || obj.userId === null) &&
            obj.status === 1
          );
        });
        list = userCatList;
        field = "title";
        fieldval = "id";
        let v = userCatList.find((x) => {
          return x.id == options.rowData.categoryId;
        });
        if (v) {
          options.value = v;
        } else {
          options.value = updatedCategory;
        }

        return (
          <Fragment>
            <Dropdown
              filter
              value={options.value}
              options={list}
              optionLabel={field}
              onChange={(e) => {
                options.editorCallback(e.value);
                changeCategory(e.value);
              }}
              placeholder="Select One"
              itemTemplate={(option) => {
                return <span>{option[field]}</span>;
              }}
            />
          </Fragment>
        );
        break;
      default:
        fieldval = "id";
        field = "name";
        list = [];
    }
  };

  const listBodyTemplate = (options, name) => {
    let list = [];
    let listName = "";
    switch (name) {
      case "activity":
        var obj = allocatedProjectData.find((x) => {
          return x.Project.title == options.projectDetails.title;
        });
        var result = obj?.Project.activities.find((y) => {
          return y.id === options.activityId;
        });
        listName = result?.title;
        break;
      case "category":
        var obj = allocatedProjectData.find((x) => {
          return x.Project.title === options.projectDetails.title;
        });
        var result = obj?.Project.categories.find((y) => {
          return y.id === options.categoryId;
        });
        listName = result?.title;
        break;
      default:
        list = [];
        listName = "";
    }
    return listName;
  };

  const updateTimesheetActivity = (param, type) => {
    try {
      timesheetApi.updateTimesheet(param).then(
        (resp) => {
          if (resp) {
            if (type === "draft") {
              //  ESAU: for ESAU region warn whenever total != 8
              const isEsauUser = currentUser?.LegalEntity?.code === "ESAU";
              if (isEsauUser) {
                if (param.totalHrs !== 8 && param.totalHrs > 0) {
                  setTotalHrWarning(true);
                  setTotalHrError(true);
                } else {
                  setTotalHrWarning(false);
                  setTotalHrError(false);
                }
              } else {
                if (param.totalHrs > 24) {
                  setTotalHrError(true);
                  setTotalHrWarning(true);
                  selectedDraftTimesheet.length > 0 && !totalHrError
                    ? setSaveDisabled(false)
                    : setSaveDisabled(true);
                } else if (param.totalHrs > 8) {
                  setTotalHrWarning(true);
                  setTotalHrError(false);
                  selectedDraftTimesheet.length > 0 && !totalHrError
                    ? setSaveDisabled(false)
                    : setSaveDisabled(true);
                } else {
                  setTotalHrWarning(false);
                  setTotalHrError(false);
                }
              }
              setTimesheetDialog(false);
              toast.success("Timesheet updated successfully...");
              fetchDraftTimesheetData({
                status: "DRAFT",
                startDate: startFilterDate,
                endDate: endFilterDate,
              });
            } else {
              setTimesheetDialog(false);
              toast.success("Timesheet updated successfully...");
              fetchRejectTimesheetData({
                status: "REJECT",
                startDate: startFilterDate,
                endDate: endFilterDate,
              });
            }
          }
        },
        (err) => {
          toast.error("Unable to update timesheet...");
        },
      );
    } catch (error) {
      toast.error("Unable to update timesheet...");
    }
  };

  /* Expend Draft Timesheet Start */

  const [isConfirmDialogVisiable, setIsConfirmDialogVisiable] = useState(false);
  const reject = () => {
    setIsConfirmDialogVisiable(true);
  };
  /* FOR CONFIRMATION DIALOG BOX */

  const confirmDeleteTimesheetActivity = (data, i, type) => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      acceptLabel: "No",
      rejectLabel: "Yes",
      reject: () => acceptFunc(data, i, type),
      accept: () => {},
    });
  };

  const acceptFunc = (data, i, type) => {
    let totalHrs;
    if (type === "draft") {
      let arr = draftTimesheetList[i.rowIndex].timesheetProjects.filter(
        (obj) => {
          return (
            obj.activityId !== data.activityId ||
            obj.categoryId !== data.categoryId ||
            obj.hours != data.hours
          );
        },
      );
      var draftData = [...draftTimesheetList];
      draftData[i.rowIndex].timesheetProjects = arr;
      totalHrs = arr.reduce((acc, curr) => acc + parseFloat(curr.hours), 0);
    } else {
      let arr = rejectTimesheetList[i.rowIndex].timesheetProjects.filter(
        (obj) => {
          return (
            obj.activityId !== data.activityId ||
            obj.categoryId !== data.categoryId ||
            obj.hours != data.hours
          );
        },
      );
      var rejectData = [...rejectTimesheetList];
      rejectData[i.rowIndex].timesheetProjects = arr;
      totalHrs = arr.reduce((acc, curr) => acc + parseFloat(curr.hours), 0);
    }
    /* Delete Draft Activity Start */
    let param = {
      id: data.id,
    };
    try {
      timesheetApi.deleteDraftActivityData(param).then(
        (resp) => {
          if (resp) {
            let param = {
              id: data.timesheetId,
              totalHours: totalHrs,
            };
            if (type === "draft") {
              updateTimesheetActivity(param, "draft");
            } else {
              updateTimesheetActivity(param, "rejected");
            }
          }
        },
        (err) => {
          toast.error("Unable to update timesheet...");
        },
      );
    } catch (error) {
      toast.error("Unable to update timesheet...");
    }
    /* Delete Draft Activity End */
    if (type === "draft") {
      setDraftTimesheetList(draftData);
    } else {
      setRejectTimesheetList(rejectData);
    }
  };

  const timesheetActivityDeleteTemplate = (rowData, i, type) => {
    return (
      <React.Fragment>
        <Button
          type="button"
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger"
          onClick={() => confirmDeleteTimesheetActivity(rowData, i, type)}
        />
      </React.Fragment>
    );
  };
  /* Delete draft timesheet by id end */

  const onTimesheetActivityEdit = (e, i, type) => {
    console.log("Updates", e, i, type);
    let actIsBillable;
    let param;
    let totalHrs;
    let isDuplicate;
    let fileterData;
    let total = 0;
    if (type === "draft") {
      const _draftTimesheetList = [
        ...draftTimesheetList[i.rowIndex].timesheetProjects,
      ];
      var { newData, index } = e;
      let actId = newData.activityId.id;
      let actTitle = newData.activityId.title;
      let catId = newData.categoryId.id;
      let catTitle = newData.categoryId.title;
      if (newData.activityId.id === undefined) {
        actIsBillable = e.data.isBillable;
      } else {
        actIsBillable = newData.activityId.isBillable;
      }
      newData["activityId"] = actId ? actId : e.data.activityId;
      newData["activityName"] = actTitle ? actTitle : e.data.activityName;
      newData["isBillable"] = actIsBillable;
      newData["categoryId"] = catId ? catId : e.data.categoryId;
      newData["categoryName"] = catTitle ? catTitle : e.data.categoryName;

      _draftTimesheetList[index] = newData;
      const updateDraftData = [...draftTimesheetList];
      updateDraftData[i.rowIndex] = _draftTimesheetList;
      totalHrs = updateDraftData[i.rowIndex].reduce(
        (acc, curr) => acc + parseFloat(curr.hours),
        0,
      );
      for (let i = 0; i < _draftTimesheetList.length; i++) {
        total += _draftTimesheetList[i].hours
          ? _draftTimesheetList[i].hours
          : 0;
      }
      param = _draftTimesheetList[index];
    } else {
      const _rejectTimesheetList = [
        ...rejectTimesheetList[i.rowIndex].timesheetProjects,
      ];
      var { newData, index } = e;
      let actId = newData.activityId.id;
      let actTitle = newData.activityId.title;
      let catId = newData.categoryId.id;
      let catTitle = newData.categoryId.title;
      if (newData.activityId.id === undefined) {
        actIsBillable = e.data.isBillable;
      } else {
        actIsBillable = newData.activityId.isBillable;
      }
      newData["activityId"] = actId ? actId : e.data.activityId;
      newData["activityName"] = actTitle ? actTitle : e.data.activityName;
      newData["isBillable"] = actIsBillable;
      newData["categoryId"] = catId ? catId : e.data.categoryId;
      newData["categoryName"] = catTitle ? catTitle : e.data.categoryName;
      _rejectTimesheetList[index] = newData;
      const updateDraftData = [...rejectTimesheetList];
      updateDraftData[i.rowIndex] = _rejectTimesheetList;
      totalHrs = updateDraftData[i.rowIndex].reduce(
        (acc, curr) => acc + parseFloat(curr.hours),
        0,
      );
      param = _rejectTimesheetList[index];
    }
    if (type === "draft") {
      fileterData = draftTimesheetList[i.rowIndex].timesheetProjects.filter(
        (x) => {
          return x.id != param.id;
        },
      );
    } else {
      fileterData = rejectTimesheetList[i.rowIndex].timesheetProjects.filter(
        (x) => {
          return x.id != param.id;
        },
      );
    }
    isDuplicate = fileterData.filter((x) => {
      return (
        x.activityId === param.activityId && x.categoryId === param.categoryId
      );
    });
    if (!param.hours || parseFloat(param.hours) <= 0) {
      toast.error("Hours must be greater than 0");
      return;
    }
    if (isDuplicate.length == 0) {
      //ESAU: enforce exactly 8 total hours when editing draft timesheet
      const isEsauUser = currentUser?.LegalEntity?.code === "ESAU";
      if (isEsauUser && totalHrs !== 8) {
        toast.error(
          "Total working hours must be exactly 8 hours per day. You entered " +
            parseFloat(totalHrs).toFixed(2) +
            " hours.",
        );
      } else if (!isEsauUser && totalHrs > 24) {
        toast.error("You cannot add more than 24 hours!");
      } else {
        try {
          timesheetApi.updateDraftData(param).then(
            (resp) => {
              if (resp) {
                let param = {
                  id: newData.timesheetId,
                  totalHours: totalHrs.toFixed(2),
                };
                updateTimesheetActivity(param, type);
              }
            },
            (err) => {
              toast.error("Unable to update timesheet...");
            },
          );
        } catch (error) {
          toast.error("Unable to update timesheet...");
        }
      }
    } else {
      toast.error("You cannot add duplicate timesheet activity!");
    }
  };

  /* Expend Draft Timesheet End */

  /* Delete draft timesheet by id end */

  /* +++++++++++++++++++++++++ Draft Timesheet Functionality Start +++++++++++++++++++++++++ */

  const toggledDraftRow = (e) => {
    if (expandedDraftRows !== null) {
      Reflect.deleteProperty(e.data, Object.keys(expandedDraftRows)[0]);
    }
    setExpandedDraftRows({ [`${Object.keys(e.data)[0]}`]: true });
  };

  const filterByMonth = (e = null) => {
    let d;
    if (e !== null) {
      setFilterMonth(e.value);
      d = new Date(e.value);
    } else {
      d = new Date(filterMonth);
    }
    const now = new Date(d);
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const fd = moment(firstDay).format("DD");
    const ld = moment(lastDay).format("DD");
    const m = moment(d).format("MM");
    const y = moment(d).format("YYYY");
    let sDate = fd + "-" + m + "-" + y;
    let eDate = ld + "-" + m + "-" + y;
    setStartFilterDate(sDate);
    setEndFilterDate(eDate);
    switch (timeshetTab) {
      case "Draft":
        fetchDraftTimesheetData({
          status: "DRAFT",
          startDate: sDate,
          endDate: eDate,
        });
        break;
      case "Review":
        fetchReviewTimesheetData({
          status: "REVIEW",
          startDate: sDate,
          endDate: eDate,
        });
        break;
      case "Approved":
        fetchApproveTimesheetData({
          status: "APPROVED",
          startDate: sDate,
          endDate: eDate,
        });
        break;
      case "Locked":
        fetchLockTimesheetData({
          status: "LOCKED",
          startDate: sDate,
          endDate: eDate,
        });
        break;
      case "Rejected":
        fetchRejectTimesheetData({
          status: "REJECT",
          startDate: sDate,
          endDate: eDate,
        });
        break;
      default:
        fetchDraftTimesheetData({
          status: "DRAFT",
          startDate: sDate,
          endDate: eDate,
        });
        break;
    }
  };

  const DraftTimesheetList = () => {
    return (
      <>
        {ViewReviewedDataDialog()}
        {totalHrError && (
          <div className="formgrid grid">
            <div className="field col-12">
              <label htmlFor="timesheet24hrs" className="p-error">
                Total hours cannot be more than 24
              </label>
            </div>
          </div>
        )}
        {totalHrWarning && (
          <div className="formgrid grid">
            <div className="field col-12">
              <label
                style={{ color: "#8B8000" }}
                htmlFor="timesheet24hrs"
                className="p-warning"
              >
                Warning: recorded hours differ from defined working hours for
                the day
              </label>
            </div>
          </div>
        )}
        <Card className="mb-2 ess-table">
          <DataTable
            key={"draft"}
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
            selectionMode="checkbox"
            value={draftTimesheetList}
            expandedRows={expandedDraftRows}
            onRowToggle={(e) => toggledDraftRow(e)}
            rowExpansionTemplate={rowDraftExpansionTemplate}
            selection={selectedDraftTimesheet}
            onSelectionChange={(e) => {
              selectDraftTimesheet(e.value);
            }}
          >
            <Column
              selectionMode="multiple"
              headerStyle={{ width: "40px" }}
              exportable={false}
            ></Column>
            <Column
              field="id"
              header="ID"
              style={{ width: "110px" }}
              sortable
            ></Column>
            {/* <Column field="date" header="Day" style={{ width: "120px" }} body={(r, o) => Util.timesheetFormatedDate(r, o, 'dddd')} ></Column> */}
            <Column
              field="date"
              header="Date"
              style={{ width: "120px", textAlign: "center" }}
              sortable
            ></Column>
            <Column
              field="createdAt"
              header="Created Date"
              body={(r, o) => Util.timesheetFormatedDate(r, o, "DD-MM-YYYY")}
              style={{ width: "100px", textAlign: "center" }}
            ></Column>
            <Column
              field=""
              header="Projects"
              body={(rowData) => Util.projectBodyTemplate(rowData)}
            ></Column>
            <Column
              field=""
              header="Total Hours"
              body={hoursRoundOff}
              style={{ width: "100px", textAlign: "center" }}
            ></Column>
            <Column
              field=""
              header="Action"
              body={draftActionBodyTemplate}
              style={{ width: "130px", textAlign: "center" }}
            ></Column>
          </DataTable>
          <div className="formgrid grid mt-2">
            <div className="field col-10"></div>
            <div className="field col-12">
              <Button
                label="Delete All"
                icon="pi pi-trash"
                className="p-button-rounded p-button-danger mr-2"
                onClick={(e) => deleteAllDraftData("draft")}
                disabled={saveDisabled}
              />
              <Button
                label="Save & Submit"
                icon="pi pi-check"
                className="p-button-rounded"
                onClick={(e) => updateDraftData("draft")}
                disabled={saveDisabled || isSubmitting}
                loading={isSubmitting}
              />
            </div>
          </div>
        </Card>
      </>
    );
  };

  /* Employee/Manager Timesheet Data List Start */
  const fetchDraftTimesheetData = (param = {}) => {
    timesheetApi.getTimesheetsData(param).then((resp) => {
      try {
        setDraftTimesheetCount(resp.data.countByStatus.draftDataCount);
        setReviewTimesheetCount(resp.data.countByStatus.reviewDataCount);
        setApproveTimesheetCount(resp.data.countByStatus.approvedDataCount);
        setLockTimesheetCount(resp.data.countByStatus.lockedDataCount);
        setRejectTimesheetCount(resp.data.countByStatus.rejectDataCount);
        setDraftTimesheetList(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };
  /* Employee/Manager Timesheet Data List End */

  const selectDraftTimesheet = (e) => {
    setSelectedDraftTimesheet(e);
    e.length > 0 && !totalHrError
      ? setSaveDisabled(false)
      : setSaveDisabled(true);
  };

  const rowDraftExpansionTemplate = (data, rowIndex) => {
    return (
      <>
        <Fieldset>
          <h2>Draft Timesheet</h2>
          <DataTable
            key={"rowDraft"}
            value={data.timesheetProjects}
            responsiveLayout="scroll"
            editMode="row"
            onRowEditComplete={(e) =>
              onTimesheetActivityEdit(e, rowIndex, "draft")
            }
          >
            <Column
              field="id"
              header="Id"
              style={{ minWidth: "8rem" }}
            ></Column>
            <Column
              field=""
              header="Project"
              body={projectBodyTemplate}
              style={{ minWidth: "8rem" }}
            ></Column>
            <Column
              field="categoryId"
              header="Category"
              editor={(options) => listEditor(options, { project: data })}
              style={{ minWidth: "8rem" }}
              body={(options) => listBodyTemplate(options, "category")}
            ></Column>
            <Column
              field="activityId"
              header="Activity"
              editor={(options) => listEditor(options, { project: data })}
              style={{ minWidth: "8rem" }}
              body={(options) => listBodyTemplate(options, "activity")}
            ></Column>
            <Column
              field="hours"
              header="Hours"
              editor={(options) => textEditor(options)}
              style={{ minWidth: "8rem" }}
            ></Column>
            <Column
              field="jiraTaskId"
              header="JIRA / Task ID"
              style={{ minWidth: "10rem" }}
              editor={(options) => textJiraTaskId(options)}
            ></Column>
            <Column
              field="description"
              header="Description"
              editor={(options) => textDescription(options)}
              style={{ minWidth: "15rem" }}
            ></Column>
            <Column
              rowEditor
              headerStyle={{ minWidth: "8rem" }}
              bodyStyle={{ textAlign: "center" }}
            ></Column>
            <Column
              field=""
              header=""
              body={(e) =>
                timesheetActivityDeleteTemplate(e, rowIndex, "draft")
              }
              style={{ minWidth: "3rem" }}
            ></Column>
          </DataTable>
        </Fieldset>
      </>
    );
  };

  const draftActionBodyTemplate = (rowData, rowIndex) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger mr-1"
          tooltip="Delete Timesheet"
          tooltipOptions={{ position: "top" }}
          onClick={(e) => deleteDraftTimesheet(e, rowData)}
        />
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-secondary mr-1"
          tooltip="Edit Timesheet"
          tooltipOptions={{ position: "top" }}
          onClick={() => editTimesheetActivity(rowData, rowIndex, "draft")}
        ></Button>
        <Button
          icon="pi pi-plus"
          className="p-button-rounded"
          tooltip="Add Timesheet"
          tooltipOptions={{ position: "top" }}
          onClick={() => addTimesheetActivity(rowData, "draft")}
        />
      </React.Fragment>
    );
  };

  const deleteDraftTimesheet = (e, rowData) => {
    confirmDialog({
      target: e.currentTarget,
      message: "Are you sure you want to delete this timesheet?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      acceptLabel: "No",
      rejectLabel: "Yes",
      reject: () => {
        try {
          // delete api call
          timesheetApi.deleteTimesheet(rowData.id).then(
            (resp) => {
              if (resp) {
                toast.success("Timesheet deleted successfully...");
                fetchDraftTimesheetData({
                  status: "DRAFT",
                  startDate: startFilterDate,
                  endDate: endFilterDate,
                });
                // getTimesheetCount();
              }
            },
            (err) => {
              // Util.handelResponse(err.response);
            },
          );
        } catch (error) {
          // Util.handelResponse(error, 2);
        }
      },
      accept: () => {},
    });
  };

  //delete all Draft timesheet
  const deleteAllDraftData = (type) => {
    confirmDialog({
      message: "Are you sure you want to delete this timesheet?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      acceptLabel: "No",
      rejectLabel: "Yes",
      reject: () => {
        let deleteAllTimesheet;
        if (type === "draft") {
          deleteAllTimesheet =
            selectedDraftTimesheet.length > 0
              ? selectedDraftTimesheet
              : draftTimesheetList;
        } else {
          deleteAllTimesheet =
            selectedRejectTimesheet.length > 0
              ? selectedRejectTimesheet
              : rejectTimesheetList;
        }
        let pram = [];
        deleteAllTimesheet.map((item) => {
          pram.push(item.id);
        });
        const param = {
          Ids: pram,
        };
        try {
          timesheetApi.deleteAllTimesheet(param).then(
            (resp) => {
              if (resp) {
                toast.success("Timesheet deleted successfully...");
                fetchDraftTimesheetData({
                  status: "DRAFT",
                  startDate: startFilterDate,
                  endDate: endFilterDate,
                });
              }
            },
            (err) => {
              // Util.handelResponse(err.response);
            },
          );
        } catch (error) {
          // Util.handelResponse(error, 2);
        }
      },
      accept: () => {},
    });
  };

  /* Save Draft Data Start */
  const updateDraftData = (type) => {
    let futureProjects = [];
    let submitReviewTimesheet;
    if (type === "draft") {
      submitReviewTimesheet =
        selectedDraftTimesheet?.length > 0
          ? selectedDraftTimesheet
          : draftTimesheetList;
    } else {
      submitReviewTimesheet =
        selectedRejectTimesheet?.length > 0
          ? selectedRejectTimesheet
          : rejectTimesheetList;
    }
    var idList = [];
    submitReviewTimesheet?.map(
      (item, index) =>
        (idList[index] = {
          id: item.id,
          comment: "",
        }),
    );
    const param = {
      timesheet: idList,
    };

    // To use conditions for if date of month is eqal to 27 than employee can submit 5 days future date timesheet
    const currentDate = new Date();
    const dayOfMonth = currentDate.getDate(); // current date
    // get last date of month
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth();
    let firstDayOfNextMonth = new Date(year, month + 1, 1);
    let lastDayOfMonth = new Date(firstDayOfNextMonth);
    lastDayOfMonth.setDate(lastDayOfMonth.getDate() - 1);

    if (type === "draft") {
      if (dayOfMonth >= submitFutureDateTimesheet.DATE) {
        //check future timesheet
        futureProjects = selectedDraftTimesheet.filter((x) => {
          let fDate = new Date(
            moment(x.date, "DD/MM/YYYY").format("YYYY/MM/DD"),
          );
          return fDate > lastDayOfMonth;
        });
      } else {
        futureProjects = selectedDraftTimesheet.filter((x) => {
          let fDate = new Date(
            moment(x.date, "DD/MM/YYYY").format("YYYY/MM/DD"),
          );
          let cDate = new Date(moment().format("YYYY/MM/DD"));
          return fDate > cDate;
        });
      }
    }

    if (futureProjects.length > 0) {
      toast.error("Unable to submit future date timesheet...");
    } else {
      setIsSubmitting(true);
      try {
        // put api call
        timesheetApi.updateDraftTimesheet(param).then(
          (resp) => {
            setIsSubmitting(false);
            if (resp.data.success === false) {
              toast.error(resp.data.message);
              return;
            }
            setSaveDisabled(true);
            var currentUser = {};
            currentUser = JSON.parse(localStorage.getItem("user"));
            if (type === "draft") {
              setSelectedDraftTimesheet(null);
              fetchDraftTimesheetData({
                status: "DRAFT",
                startDate: startFilterDate,
                endDate: endFilterDate,
              });
            } else {
              setSelectedRejectTimesheet(null);
              fetchRejectTimesheetData({
                status: "REJECT",
                startDate: startFilterDate,
                endDate: endFilterDate,
              });
            }
            toast.success(
              "Your Timesheet has been shared with " +
                currentUser.superior.firstName +
                " " +
                currentUser.superior.lastName +
                " for approval",
            );
          },
          (err) => {
            setIsSubmitting(false);
            toast.error(
              err?.response?.data?.message ||
                err?.response?.data?.error ||
                "Unable to update timesheet...",
            );
            fetchDraftTimesheetData({
              status: "DRAFT",
              startDate: startFilterDate,
              endDate: endFilterDate,
            });
          },
        );
      } catch (error) {
        setIsSubmitting(false);
        toast.error(
          error?.response?.data?.message || "Unable to update timesheet...",
        );
      }
    }
  };

  /* Sav draft Data End */

  /* +++++++++++++++++++++++++ Draft Timesheet Functionality End +++++++++++++++++++++++++ */

  /* +++++++++++++++++++++++++ Review Timesheet Functionality Start +++++++++++++++++++++++++ */

  const reviewDialogCall = (rowData) => {
    setCurrentReviewRow(rowData);
    setReviewDialog(true);
  };

  const ViewReviewedDataDialog = () => {
    return (
      <div className="orders-subtable">
        <Dialog
          className="pop-up-dialog custom_popup"
          header={"View Reviewed Timesheet (" + currentReviewRow?.date + ")"}
          visible={reviewDialog}
          onHide={() => setReviewDialog(false)}
        >
          <Fieldset>
            <div style={{ width: "100%", overflowX: "auto" }}>
              <DataTable
                key={"viewRevie"}
                columnResizeMode="fit"
                scrollable="horizontal"
                stripedRows
                value={currentReviewRow?.timesheetProjects}
                responsiveLayout="scroll"
              >
                <Column field="id" header="Id"></Column>
                <Column
                  field=""
                  header="Project"
                  body={projectBodyTemplate}
                  style={{ minWidth: "15rem" }}
                ></Column>
                <Column
                  field="categoryId"
                  header="Category"
                  style={{ minWidth: "10rem" }}
                  body={categoryBodyTemplate}
                ></Column>
                <Column
                  field="activityId"
                  header="Activity"
                  style={{ minWidth: "10rem" }}
                  body={activityBodyTemplate}
                ></Column>
                <Column
                  header="Billing Type"
                  body={ChargeableOrNot}
                  style={{ minWidth: "10rem" }}
                ></Column>
                <Column field="hours" header="Hours"></Column>
                <Column
                  field="jiraTaskId"
                  header="JIRA / Task ID"
                  style={{ minWidth: "10rem" }}
                ></Column>
                <Column
                  field="description"
                  header="Description"
                  style={{ minWidth: "13rem" }}
                ></Column>
              </DataTable>
            </div>
          </Fieldset>
        </Dialog>
      </div>
    );
  };

  /* open Popup on recall button start */
  const recallTimesheet = (rowData) => {
    setEditRecallData(rowData);
    setRecallDialog(true);
  };

  const multipleRecallTimesheet = (rowData) => {
    setEditMultipleRecallData(rowData);
    setMultipleRecallDialog(true);
  };
  /* open Popup on recall button end */

  const selectReviewRecall = (e) => {
    if (e.value.length > 0) {
      setReviewRecallDisabled(false);
    } else {
      setReviewRecallDisabled(true);
    }
    setSelectedReviewTimesheet(e.value);
  };

  const ReviewTimesheetList = () => {
    return (
      <>
        {ViewReviewedDataDialog()}
        <Card className="mb-2 ess-table">
          <DataTable
            key={"rievewTimesheet"}
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
            ref={dt}
            value={reviewTimesheetList}
            selection={selectedReviewTimesheet}
            onSelectionChange={(e) => selectReviewRecall(e)}
            resizableColumns
            columnResizeMode="fit"
            scrollable="horizontal"
            stripedRows
          >
            <Column
              selectionMode="multiple"
              headerStyle={{ width: "40px", textAlign: "center" }}
              exportable={false}
            ></Column>
            <Column
              field="id"
              header="ID"
              style={{ width: "100px" }}
              sortable
            ></Column>
            <Column
              field="date"
              header="Date"
              style={{ width: "100px", textAlign: "center" }}
              sortable
            ></Column>
            <Column
              field=""
              header="Projects"
              body={(rowData) => Util.projectBodyTemplate(rowData)}
              style={{}}
            ></Column>
            <Column
              field=""
              header="Total Hours"
              body={hoursRoundOff}
              style={{ width: "100px", textAlign: "center" }}
            ></Column>
            {reviewAction && (
              <Column
                field=""
                header="Action"
                body={reviewActionBodyTemplate}
                style={{ width: "100px", textAlign: "center" }}
              ></Column>
            )}
          </DataTable>
          <div className="formgrid grid mt-2">
            <div className="field col-10"></div>
            <div className="field col-12">
              <Button
                label="Recall"
                icon="pi pi-undo"
                className="p-button-rounded"
                onClick={(rowData) => multipleRecallTimesheet(rowData)}
                disabled={reviewRecallDisabled}
              />
            </div>
          </div>
        </Card>
      </>
    );
  };

  /* Review Timesheet Data List Start */
  const fetchReviewTimesheetData = (param = {}) => {
    timesheetApi.getTimesheetsData(param).then((resp) => {
      try {
        setDraftTimesheetCount(resp.data.countByStatus.draftDataCount);
        setReviewTimesheetCount(resp.data.countByStatus.reviewDataCount);
        setApproveTimesheetCount(resp.data.countByStatus.approvedDataCount);
        setLockTimesheetCount(resp.data.countByStatus.lockedDataCount);
        setRejectTimesheetCount(resp.data.countByStatus.rejectDataCount);
        setReviewTimesheetList(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };
  /* Review Timesheet Data List End */

  const reviewActionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-undo"
          type="button"
          className="p-button-rounded mr-1"
          tooltip="Recall Timesheet"
          tooltipOptions={{ position: "top" }}
          onClick={() => recallTimesheet(rowData)}
        />
        <Button
          icon="pi pi-eye"
          type="button"
          className="p-button-rounded p-button-secondary"
          tooltip="View Timesheet"
          tooltipOptions={{ position: "top" }}
          onClick={() => reviewDialogCall(rowData)}
        />
      </React.Fragment>
    );
  };

  /* For Recall Popup Start */
  const updateRecallData = (data) => {
    data = { ...data, id: editRecallData.id };
    let param = {
      id: editRecallData.id,
      reason: data.reason,
    };
    try {
      // put api call
      timesheetApi.updateRecallTimesheet(param).then(
        (resp) => {
          if (resp) {
            toast.info("Timesheet moved review to draft mode...");
            fetchReviewTimesheetData({
              status: "REVIEW",
              startDate: startFilterDate,
              endDate: endFilterDate,
            });
            // getTimesheetCount();
          }
        },
        (err) => {
          toast.error("Unable to recall timesheet...");
        },
      );
    } catch (error) {
      toast.error("Unable to recall timesheet...");
    }
  };

  const updateMultipleRecallData = (data) => {
    data = { ...data, Ids: editMultipleRecallData.id };
    var idList = [];
    selectedReviewTimesheet.map((item, key) => {
      idList[key] = item.id;
    });
    let param = {
      Ids: idList,
      reason: data.reason,
    };
    try {
      // put api call
      timesheetApi.updateMultipleRecallTimesheet(param).then(
        (resp) => {
          if (resp) {
            toast.info("Timesheet moved review to draft mode...");
            setReviewRecallDisabled(true);
            fetchReviewTimesheetData({
              status: "REVIEW",
              startDate: startFilterDate,
              endDate: endFilterDate,
            });
            // getTimesheetCount();
          }
        },
        (err) => {
          toast.error("Unable to recall timesheet...");
        },
      );
    } catch (error) {
      toast.error("Unable to recall timesheet...");
    }
  };
  /* For Recall Popup End */

  /* Dialog Box for Recall timesheet Start */
  const RecallTimesheetDialog = () => {
    return (
      <Dialog
        className="pop-up-dialog-recall"
        header={"Recall Timesheet (" + editRecallData?.date + ")"}
        style={{ width: "530px" }}
        visible={recallDialog}
        onHide={() => setRecallDialog(false)}
      >
        <RecallTimesheetForm
          updateRecall={(data) => updateRecallData(data)}
          editRecall={editRecallData}
          onClose={(e) => {
            setRecallDialog(false);
          }}
        />
      </Dialog>
    );
  };

  const MultipleRecallTimesheetDialog = () => {
    return (
      <Dialog
        className="pop-up-dialog-recall"
        header="Recall Timesheet"
        style={{ width: "380px" }}
        visible={multipleRecallDialog}
        onHide={() => setMultipleRecallDialog(false)}
      >
        <RecallTimesheetForm
          updateRecall={(data) => updateMultipleRecallData(data)}
          editRecall={editMultipleRecallData}
          onClose={(e) => {
            setMultipleRecallDialog(false);
          }}
        />
      </Dialog>
    );
  };
  /* Dialog Box for Recall timesheet End */

  /* +++++++++++++++++++++++++ Review Timesheet Functionality End +++++++++++++++++++++++++ */

  /* +++++++++++++++++++++++++ Approved Timesheet Functionality Start +++++++++++++++++++++++++ */

  const approvedDialogCall = (rowData) => {
    setCurrentApprovedRow(rowData);
    setApprovedDialog(true);
  };

  const ViewApprovedDataDialog = () => {
    return (
      <div className="orders-subtable">
        <Dialog
          className="pop-up-dialog custom_popup"
          header={"View Approved Timesheet (" + currentApprovedRow?.date + ")"}
          visible={approvedDialog}
          onHide={() => setApprovedDialog(false)}
        >
          <Fieldset>
            <div>
              <DataTable
                key={"viewAPProve"}
                columnResizeMode="fit"
                scrollable="horizontal"
                stripedRows
                value={currentApprovedRow?.timesheetProjects}
                responsiveLayout="scroll"
              >
                <Column field="id" header="Id"></Column>
                <Column
                  field=""
                  header="Project"
                  body={projectBodyTemplate}
                  style={{ minWidth: "15rem" }}
                ></Column>
                <Column
                  field="categoryId"
                  header="Category"
                  style={{ minWidth: "10rem" }}
                  body={categoryBodyTemplate}
                ></Column>
                <Column
                  field="activityId"
                  header="Activity"
                  style={{ minWidth: "10rem" }}
                  body={activityBodyTemplate}
                ></Column>
                <Column
                  header="Billing Type"
                  body={ChargeableOrNot}
                  style={{ minWidth: "10rem" }}
                ></Column>
                <Column field="hours" header="Hours"></Column>
                <Column
                  field="jiraTaskId"
                  header="JIRA / Task ID"
                  style={{ minWidth: "10rem" }}
                ></Column>
                <Column
                  field="description"
                  header="Description"
                  style={{ minWidth: "13rem" }}
                ></Column>
              </DataTable>
            </div>
          </Fieldset>
        </Dialog>
      </div>
    );
  };

  /* open Popup on approved recall button start */
  const requestRecallTimesheet = (rowData) => {
    setEditReqRecallData(rowData);
    setReqRecallDialog(true);
  };

  const multipleApprovedRecallTimesheet = (rowData) => {
    setEditMultipleReqRecallData(rowData);
    setMultipleReqRecallDialog(true);
  };
  /* open Popup on approved recall button end */

  const selectApprovedRecall = (e) => {
    if (e.value.length > 0) {
      setApprovedRecallDisabled(false);
    } else {
      setApprovedRecallDisabled(true);
    }
    setSelectedApproveTimesheet(e.value);
  };

  const ApproveTimesheetList = () => {
    return (
      <>
        {ViewApprovedDataDialog()}
        <Card className="mb-2 ess-table">
          <DataTable
            key={"approvTimesheet"}
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
            ref={dt}
            value={approveTimesheetList}
            selection={selectedApproveTimesheet}
            onSelectionChange={(e) => selectApprovedRecall(e)}
            resizableColumns
            columnResizeMode="fit"
            scrollable="horizontal"
            stripedRows
          >
            <Column
              selectionMode="multiple"
              headerStyle={{ width: "40px" }}
              exportable={false}
            ></Column>
            <Column
              field="id"
              header="ID"
              style={{ width: "100px" }}
              sortable
            ></Column>
            <Column
              field="date"
              header="Date"
              style={{ width: "100px", textAlign: "center" }}
              sortable
            ></Column>
            <Column
              field=""
              header="Projects"
              body={(rowData) => Util.projectBodyTemplate(rowData)}
            ></Column>
            <Column
              field=""
              header="Total Hours"
              body={hoursRoundOff}
              style={{ width: "100px", textAlign: "center" }}
            ></Column>
            <Column
              field=""
              header="Action"
              body={approvedActionBodyTemplate}
              style={{ width: "100px", textAlign: "center" }}
            ></Column>
          </DataTable>
          <div className="formgrid grid mt-2">
            <div className="field col-10"></div>
            <div className="field col-12">
              <Button
                label="Recall"
                icon="pi pi-undo"
                className="p-button-rounded"
                onClick={(rowData) => multipleApprovedRecallTimesheet(rowData)}
                disabled={approvedRecallDisabled}
              />
            </div>
          </div>
        </Card>
      </>
    );
  };

  /* Approve Timesheet Data List Start */
  const fetchApproveTimesheetData = (param = {}) => {
    timesheetApi.getTimesheetsData(param).then((resp) => {
      try {
        setDraftTimesheetCount(resp.data.countByStatus.draftDataCount);
        setReviewTimesheetCount(resp.data.countByStatus.reviewDataCount);
        setApproveTimesheetCount(resp.data.countByStatus.approvedDataCount);
        setLockTimesheetCount(resp.data.countByStatus.lockedDataCount);
        setRejectTimesheetCount(resp.data.countByStatus.rejectDataCount);
        setApproveTimesheetList(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };
  /* Approve Timesheet Data List End */

  const approvedActionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-undo"
          type="button"
          className="p-button-rounded mr-1"
          tooltip="Request For Recall"
          tooltipOptions={{ position: "top" }}
          onClick={() => requestRecallTimesheet(rowData)}
        />
        <Button
          icon="pi pi-eye"
          type="button"
          className="p-button-rounded p-button-secondary"
          tooltip="View Timesheet"
          tooltipOptions={{ position: "top" }}
          onClick={() => approvedDialogCall(rowData)}
        />
      </React.Fragment>
    );
  };

  /* For Request Recall Popup Start */
  const updateRequestRecallData = (data) => {
    data = { ...data, Ids: editReqRecallData.id };
    let param = {
      Ids: [editReqRecallData.id],
      reason: data.reason,
    };
    try {
      // put api call
      timesheetApi.updateRequestRecallTimesheet(param).then(
        (resp) => {
          if (resp) {
            toast.info("Timesheet moved approved to action mode...");
            fetchApproveTimesheetData({
              status: "APPROVED",
              startDate: startFilterDate,
              endDate: endFilterDate,
            });
          }
        },
        (err) => {
          toast.error("Unable to request recall timesheet...");
        },
      );
    } catch (error) {
      toast.error("Unable to request recall timesheet...");
    }
  };

  const updateMultipleRequestRecallData = (data) => {
    data = { ...data, Ids: editMultipleReqRecallData.id };
    var idList = [];
    selectedApproveTimesheet.map((item, key) => {
      idList[key] = item.id;
    });
    let param = {
      Ids: idList,
      reason: data.reason,
    };
    try {
      // put api call
      timesheetApi.updateRequestRecallTimesheet(param).then(
        (resp) => {
          if (resp) {
            toast.info("Timesheet moved approved to action mode...");
            setApprovedRecallDisabled(true);
            fetchApproveTimesheetData({
              status: "APPROVED",
              startDate: startFilterDate,
              endDate: endFilterDate,
            });
          }
        },
        (err) => {
          toast.error("Unable to request recall timesheet...");
        },
      );
    } catch (error) {
      toast.error("Unable to request recall timesheet...");
    }
  };
  /* For Request Recall Popup End */

  /* Dialog Box for Approved Recall timesheet Start */
  const RequestRecallTimesheetDialog = () => {
    return (
      <Dialog
        className="pop-up-dialog-request-recall"
        header={"Request Recall Timesheet (" + editReqRecallData?.date + ")"}
        style={{ width: "540px" }}
        visible={reqRecallDialog}
        onHide={() => setReqRecallDialog(false)}
      >
        <RequestRecallTimesheetPopup
          updateRequestRecall={(data) => updateRequestRecallData(data)}
          editReqRecall={editReqRecallData}
          onClose={(e) => {
            setReqRecallDialog(false);
          }}
        />
      </Dialog>
    );
  };

  const MultipleRequestRecallTimesheetDialog = () => {
    return (
      <Dialog
        className="pop-up-dialog-recall"
        header="Request Recall Timesheet"
        style={{ width: "380px" }}
        visible={multipleReqRecallDialog}
        onHide={() => setMultipleReqRecallDialog(false)}
      >
        <RequestRecallTimesheetPopup
          updateRequestRecall={(data) => updateMultipleRequestRecallData(data)}
          editReqRecall={editMultipleReqRecallData}
          onClose={(e) => {
            setMultipleReqRecallDialog(false);
          }}
        />
      </Dialog>
    );
  };
  /* Dialog Box for Approved Recall timesheet End */

  /* +++++++++++++++++++++++++ Approved Timesheet Functionality End +++++++++++++++++++++++++ */

  /* +++++++++++++++++++++++++ Lock Timesheet Functionality Start +++++++++++++++++++++++++ */

  const lockedDialogCall = (rowData) => {
    setCurrentLockedRow(rowData);
    setLockedDialog(true);
  };

  const lockedActionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          type="button"
          className="p-button-rounded p-button-secondary"
          tooltip="View Timesheet"
          tooltipOptions={{ position: "top" }}
          onClick={() => lockedDialogCall(rowData)}
        />
      </React.Fragment>
    );
  };

  const LockedTimesheetList = () => {
    return (
      <>
        {ViewLockedDataDialog()}
        <Card className="mb-2 ess-table">
          <DataTable
            key={"LockedTimesheetList"}
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
            scrollable
            stripedRows
            value={lockTimesheetList}
          >
            <Column
              field="id"
              header="ID"
              style={{ width: "40px" }}
              sortable
            ></Column>
            <Column
              field="date"
              header="Date"
              style={{ width: "100px" }}
              sortable
            ></Column>
            <Column
              field=""
              header="Projects"
              body={(rowData) => Util.projectBodyTemplate(rowData)}
            ></Column>
            <Column
              field=""
              header="Total Hours"
              body={hoursRoundOff}
              style={{ width: "100px", textAlign: "center" }}
            ></Column>
            <Column
              field=""
              header="Action"
              body={lockedActionBodyTemplate}
              style={{ width: "100px", textAlign: "center" }}
            ></Column>
          </DataTable>
        </Card>
      </>
    );
  };

  /* Lock Timesheet Data List Start */
  const fetchLockTimesheetData = (param = {}) => {
    timesheetApi.getTimesheetsData(param).then((resp) => {
      try {
        setDraftTimesheetCount(resp.data.countByStatus.draftDataCount);
        setReviewTimesheetCount(resp.data.countByStatus.reviewDataCount);
        setApproveTimesheetCount(resp.data.countByStatus.approvedDataCount);
        setLockTimesheetCount(resp.data.countByStatus.lockedDataCount);
        setRejectTimesheetCount(resp.data.countByStatus.rejectDataCount);
        setLockTimesheetList(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };
  /* Lock Timesheet Data List End */

  const ViewLockedDataDialog = (data) => {
    return (
      <div className="orders-subtable">
        <Dialog
          className="pop-up-dialog custom_popup"
          header={"View Locked Timesheet (" + currentLockedRow?.date + ")"}
          visible={lockedDialog}
          onHide={() => setLockedDialog(false)}
        >
          <Fieldset>
            <div>
              <DataTable
                key={"viewLook"}
                columnResizeMode="fit"
                scrollable="horizontal"
                stripedRows
                value={currentLockedRow?.timesheetProjects}
                responsiveLayout="scroll"
              >
                <Column field="id" header="Id"></Column>
                <Column
                  field=""
                  header="Project"
                  body={projectBodyTemplate}
                  style={{ minWidth: "15rem" }}
                ></Column>
                <Column
                  field="categoryId"
                  header="Category"
                  style={{ minWidth: "10rem" }}
                  body={categoryBodyTemplate}
                ></Column>
                <Column
                  field="activityId"
                  header="Activity"
                  style={{ minWidth: "10rem" }}
                  body={activityBodyTemplate}
                ></Column>
                <Column
                  header="Billing Type"
                  body={ChargeableOrNot}
                  style={{ minWidth: "10rem" }}
                ></Column>
                <Column
                  field="hours"
                  header="Hours"
                  editor={(options) => textEditor(options)}
                  style={{ minWidth: "8rem" }}
                ></Column>
                <Column
                  field="jiraTaskId"
                  header="JIRA / Task ID"
                  style={{ minWidth: "10rem" }}
                ></Column>
                <Column
                  field="description"
                  header="Description"
                  style={{ minWidth: "13rem" }}
                ></Column>
              </DataTable>
            </div>
          </Fieldset>
        </Dialog>
      </div>
    );
  };

  /* +++++++++++++++++++++++++ Lock Timesheet Functionality End +++++++++++++++++++++++++ */

  /* +++++++++++++++++++++++++ Reject Timesheet Functionality Start +++++++++++++++++++++++++ */

  const toggledRejectedRow = (e) => {
    if (expandedRejectedRows !== null) {
      Reflect.deleteProperty(e.data, Object.keys(expandedRejectedRows)[0]);
    }
    setExpandedRejectedRows({ [`${Object.keys(e.data)[0]}`]: true });
  };

  const RejectTimesheetList = () => {
    return (
      <>
        {ViewReviewedDataDialog()}
        {/* {TimesheetDlg(editableDraftTimesheet, draftRowIndex, "rejected")} */}
        <Card className="mb-2 ess-table">
          <DataTable
            key={"rejevtTimesheet"}
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
            value={rejectTimesheetList}
            selection={selectedRejectTimesheet}
            onRowToggle={(e) => toggledRejectedRow(e)}
            expandedRows={expandedRejectedRows}
            rowExpansionTemplate={rowRejectedExpansionTemplate}
            onSelectionChange={(e) => selectRejectedTimesheet(e)}
          >
            <Column
              selectionMode="multiple"
              headerStyle={{ width: "40px" }}
              exportable={false}
            ></Column>
            <Column
              field="id"
              header="ID"
              style={{ width: "100px" }}
              sortable
            ></Column>
            <Column
              field="date"
              header="Date"
              style={{ width: "100px", textAlign: "center" }}
              sortable
            ></Column>
            <Column field="reason" header="Reason" style={{}}></Column>
            <Column
              field=""
              header="Projects"
              body={(rowData) => Util.projectBodyTemplate(rowData)}
            ></Column>
            <Column
              field=""
              header="Total Hours"
              body={hoursRoundOff}
              style={{ width: "100px", textAlign: "center" }}
            ></Column>
            <Column
              field=""
              header="Action"
              body={rejectActionBodyTemplate}
              style={{ width: "100px", textAlign: "center" }}
            ></Column>
          </DataTable>
          <div className="formgrid grid mt-2">
            <div className="field col-2">
              <Button
                label="Save & Submit"
                style={{ width: "150px" }}
                icon="pi pi-check"
                className="p-button-rounded"
                onClick={(e) => updateDraftData("reject")}
                disabled={rejectedDisabled}
              />
            </div>
          </div>
        </Card>
      </>
    );
  };

  /* Reject Timesheet Data List Start */
  const fetchRejectTimesheetData = (param = {}) => {
    timesheetApi.getTimesheetsData(param).then((resp) => {
      try {
        setDraftTimesheetCount(resp.data.countByStatus.draftDataCount);
        setReviewTimesheetCount(resp.data.countByStatus.reviewDataCount);
        setApproveTimesheetCount(resp.data.countByStatus.approvedDataCount);
        setLockTimesheetCount(resp.data.countByStatus.lockedDataCount);
        setRejectTimesheetCount(resp.data.countByStatus.rejectDataCount);
        setRejectTimesheetList(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };
  /* Reject Timesheet Data List End */

  const selectRejectedTimesheet = (e) => {
    setSelectedRejectTimesheet(e.value);
    e.value.length > 0 ? setRejectedDisabled(false) : setRejectedDisabled(true);
  };

  const rejectActionBodyTemplate = (rowData, rowIndex) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-secondary mr-2"
          tooltip="Edit Timesheet"
          tooltipOptions={{ position: "top" }}
          onClick={() => editTimesheetActivity(rowData, rowIndex, "rejected")}
        />
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-info"
          tooltip="View Timesheet"
          tooltipOptions={{ position: "top" }}
          onClick={() => reviewDialogCall(rowData)}
        />
      </React.Fragment>
    );
  };

  const rowRejectedExpansionTemplate = (data, rowIndex) => {
    return (
      <div className="orders-subtable">
        <DataTable
          key={"rowRejectEx"}
          value={data.timesheetProjects}
          responsiveLayout="scroll"
          editMode="row"
          onRowEditComplete={(e) =>
            onTimesheetActivityEdit(e, rowIndex, "rejected")
          }
        >
          <Column field="id" header="Id"></Column>
          <Column field="" header="Project" body={projectBodyTemplate}></Column>
          <Column
            field="categoryId"
            header="Category"
            editor={(options) => listEditor(options, { project: data })}
            style={{ minWidth: "8rem" }}
            body={(options) => listBodyTemplate(options, "category")}
          ></Column>
          <Column
            field="activityId"
            header="Activity"
            editor={(options) => listEditor(options, { project: data })}
            style={{ minWidth: "8rem" }}
            body={(options) => listBodyTemplate(options, "activity")}
          ></Column>
          <Column
            header="Billing Type"
            style={{ minWidth: "10rem" }}
            body={ChargeableOrNot}
          ></Column>
          <Column field="jiraTaskId" header="JIRA / Task ID"></Column>
          <Column
            field="hours"
            header="Hours"
            editor={(options) => textEditor(options)}
            style={{ minWidth: "8rem" }}
          ></Column>
          <Column
            field="jiraTaskId"
            header="JIRA / Task ID"
            editor={(options) => textJiraTaskId(options)}
            style={{ minWidth: "8rem" }}
          ></Column>
          <Column
            field="description"
            header="Description"
            editor={(options) => textDescription(options)}
            style={{ minWidth: "13rem" }}
          ></Column>
          <Column
            rowEditor
            headerStyle={{ minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
          <Column
            field=""
            header=""
            body={(e) =>
              timesheetActivityDeleteTemplate(e, rowIndex, "rejected")
            }
            style={{ minWidth: "3rem" }}
          ></Column>
        </DataTable>
      </div>
    );
  };
  /* +++++++++++++++++++++++++ Reject Timesheet Functionality End+++++++++++++++++++++++++  */

  return (
    <div className="ess-page">
      {TimesheetDlg()}
      {NewTimesheetActivityDialog()}
      {/* {TimesheetDialog(editableDraftTimesheet, draftRowIndex)} */}
      <Toolbar
        className="mb-2"
        left={leftToolbarTemplate}
        right={rightToolbarTemplate}
      ></Toolbar>
      {draftAction && DraftTimesheetList()}
      {reviewAction && ReviewTimesheetList()}
      {approveAction && ApproveTimesheetList()}
      {lockedAction && LockedTimesheetList()}
      {rejectAction && RejectTimesheetList()}
      {RecallTimesheetDialog()}
      {MultipleRecallTimesheetDialog()}
      {RequestRecallTimesheetDialog()}
      {MultipleRequestRecallTimesheetDialog()}
    </div>
  );
};

export default EmployeeManagerTimesheet;
